import { db } from '../../firebase/config';
import fetchOwnAdress from './fetchOwnAdress';
import { client } from '../../hooks/Client';
import shouldAutoMarkPlanned from './shouldAutoMarkPlanned';
import recordStatusChange from '../statusHistory/recordStatusChange';

/**
 * Auto-advance the address linked to a just-scheduled huisbezoek to status
 * "planned" (Ingepland). Reads the address fresh from Firestore at save-time
 * so the decision is made against the live status, not a stale hook snapshot.
 *
 * AI-CONTEXT: See docs/patterns.md#data-fresh-fetch-on-mutation
 *
 * @param {object|null|undefined} task - The saved task document
 * @param {string} [changedBy] - Users.ID van wie de afspraak opsloeg
 * @returns {Promise<boolean>} true when the status was changed
 */
const autoMarkAdressPlanned = async (task, changedBy) => {
    // Pre-check the task fields before querying — also guards the .where()
    // against an undefined AdressID or empty client.
    if (!client) return false;
    if (!shouldAutoMarkPlanned(task, '')) return false;

    // Eén leespad voor 'mijn eigen huishouden': eigen organisatie, ID-veld,
    // niet verwijderd. AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
    const doc = await fetchOwnAdress(task.AdressID);
    if (!doc) return false;
    const previousStatus = doc.data().Status;
    if (!shouldAutoMarkPlanned(task, previousStatus)) return false;

    await db.collection('Adresses').doc(doc.id).update({ Status: 'planned' });
    await recordStatusChange({
        entityType: 'adress',
        entityID: task.AdressID,
        fromStatus: previousStatus,
        toStatus: 'planned',
        changedBy,
    });
    return true;
};

export default autoMarkAdressPlanned;
